/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import UniversityList from './UniversityList';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json';
import { addUniversityData, getUniversityData, editUniversity, resetUniversity, resetUniversityList } from '../actions/masterManagementAction';
import { SET_UNIVERSITIES } from '../../../common/constants/ActionTypes';
import Select from 'react-select';


const UniversityForm = ({ addUniversity, setAddUniversity, setUniversityState, setQualificationNameCode, universityCode, universityName, universityState, qualificationNameCode, setUniversityCode, setUniversityName }) => {
  const dispatch = useDispatch();
  const inputRef = useRef()
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange"
  });
  const onSubmit = (data, addUniversity, setAddUniversity) => {
    let requestBody = {
      "universityDto": {
        "universityName": data.universityName,
        "stateCode": universityState,
        "qualificationNameCode": data.qualificationNameCode,
        "isActive": data.isActive
      }
    };
    dispatch(resetUniversityList());
    if (addUniversity.Mode == 'Add') {
      dispatch(addUniversityData(requestBody, setAddUniversity, setUniversityState, setUniversityName, setUniversityCode, setQualificationNameCode));
    }
    else if (addUniversity.Mode == 'Edit') {
      requestBody.universityDto.universityCode = addUniversity.universitycode;
      requestBody.universityDto.stateCode = addUniversity.universityState;
      dispatch(editUniversity(requestBody, setAddUniversity, setUniversityState, setUniversityName, setUniversityCode, setQualificationNameCode));
    }
  }

  useEffect(() => {
    if (addUniversity && addUniversity.Mode == 'Add') {
      dispatch(resetUniversityList());
      setUniversityState('');
      setUniversityName('');
      setQualificationNameCode('');
    }

    addUniversity.Mode == "Edit" && addUniversity.universitycode > 0 && dispatch(getUniversityData(addUniversity.universitycode));

    dispatch({
      type: SET_UNIVERSITIES,
      payload: {},
    });
    // eslint-disable-next-line
  }, [])

  const onUniversityStateChange = (e) => {
    dispatch(resetUniversity());
    dispatch(resetUniversityList());
    let universitySelectedState = e.target.value;
    setUniversityState(universitySelectedState);
    // dispatch(getUniversityListPagination(0,10,universitySelectedState,universityName));
  }

  const { universityStates, universityData } = useSelector((state) => state.masterManagementReducer, shallowEqual);

  const onCancelButton = () => {
    setAddUniversity({ "Mode": false });
    setUniversityState('');
    setUniversityName('');
    setUniversityCode('');
    setQualificationNameCode('');
    dispatch(resetUniversity());
    dispatch(resetUniversityList());
  }


  const universityOptions = universityStates?.map(el => ({
  value: el.code,
  label: el.name
})) || []; 



  return addUniversity.Mode == false ? (
    <div>
      <UniversityList
        setAddUniversity={setAddUniversity}
      />
    </div>
  ) : (
    <div>
      <form>
        <div className="border border-light text-center w-100 p-5" >
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-6'>
                <h4><p className='float-left'>{addUniversity.Mode == 'Add' ? masterLabels.universityForm.Add_University : masterLabels.universityForm.Update_University}</p></h4>
              </div>
            </div>
          </div>
          <br />
          <div className='form-group'>
            <div className='row'>
              <div className='col-md-2'>
                <label className="float-left font-weight-bold">{masterLabels.universityForm.States}<span className="redColor">*</span></label>
                {/* <select
                  className='form-control mt-1'
                  name="universityState"
                  onInput={onUniversityStateChange}
                  ref={register({ required: true })}
                  defaultValue={addUniversity && addUniversity.Mode == 'Edit' && addUniversity.universityState}
                  disabled={addUniversity && addUniversity.Mode == 'Edit' && true}
                >

                  <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                  {universityStates && universityStates && universityStates.length > 0 && universityStates.map((element, index) =>
                    <option key={index} value={element.code}>{element.name}</option>
                  )}
                </select> */}
<br />
<Select
  // className="form-control mt-1"
  name="universityState"
  options={universityOptions}
  onChange={selectedOption => {
    onUniversityStateChange({
      target: {
        name: 'universityState',
        value: selectedOption?.value || ''
      }
    });
  }}
  value={
    universityOptions.find(option =>
      option.value === (addUniversity?.Mode === 'Edit' ? addUniversity?.universityState : universityState)
    ) || null
  }
  placeholder={commonLabels.COMBO_SELECT}
  isClearable
  isDisabled={addUniversity?.Mode === 'Edit'}
  ref={inputRef}
/>

                {_.get("universityState.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
              </div>

              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.universityForm.University_Name}<span className="redColor">*</span></label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="universityName"
                  placeholder={masterLabels.universityForm.University_Name}
                  ref={register({ required: true, maxLength: 300 })}
                  defaultValue={addUniversity && addUniversity.Mode == 'Edit' && universityData && universityData.universityDto && universityData.universityDto.universityName ? universityData.universityDto.universityName : ''}
                  onChange={(event) => setUniversityName(event.target.value)}
                />
                {_.get("universityName.type", errors) === "required" && (
                  <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
                )}
                {_.get("universityName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_300}</p>
                )}
              </div>
              <div className='col-md-3'>
                <label className='font-weight-bold float-left' >{masterLabels.universityForm.Qualification_Name_Code}</label>
                <input
                  type="text"
                  className="form-control input-sm"
                  name="qualificationNameCode"
                  placeholder={masterLabels.universityForm.Qualification_Name_Code}
                  ref={register({ maxLength: 300 })}
                  defaultValue={addUniversity && addUniversity.Mode == 'Edit' && universityData && universityData.universityDto && universityData.universityDto.qualificationNameCode ? universityData.universityDto.qualificationNameCode : ''}
                  onChange={(event) => setQualificationNameCode(event.target.value)}
                  disabled={addUniversity && addUniversity.Mode == 'Edit' && true}
                />

                {_.get("universityName.type", errors) === "maxLength" && (
                  <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_300}</p>
                )}
              </div>
              {/* <div className='col-md-1'>
                <label className='float-left font-weight-bold text-left w-100'>{masterLabels.universityForm.University_Status}?<span className="redColor">*</span>&nbsp;&nbsp;</label>
                <input
                  className='float-left text-left'
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={universityData && universityData.universityDto && universityData.universityDto.isActive}
                  ref={register({})}
                />
              </div> */}

              <div className='form-group col-md-2 mt-4'>
                <div className="form-check d-flex align-items-center gap-5">
                  <label className='form-check-label font-weight-bold' htmlFor="isActiveCheckbox">
                    {masterLabels.universityForm.University_Status}?
                  </label>
                  <input
                    className='form-check-input'
                    type="checkbox"
                    name="isActive"
                    value={true}
                    defaultChecked={universityData && universityData.universityDto && universityData.universityDto.isActive}
                   ref={register({})}
                  />
                </div>
              </div>
            </div>
            <div className="row mt-5">
              <div className="col-md-10 d-flex justify-content-end">
                <button type="button" className="btn btn-secondary " onClick={() => onCancelButton()}>
                  {commonLabels.BUTTONS.CANCEL}
                </button>
                <button type="submit" className=" btn btn-primary custom_button  ms-2  " onClick={handleSubmit((e) => { onSubmit(e, addUniversity, setAddUniversity); })}>
                  {commonLabels.BUTTONS.SAVE}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default UniversityForm;